import { FetchJson } from './Fetch';

const classesAPI = {
    getClassList:(data:object) => FetchJson.get("/class", data),
    getAdminClassList:(data:object) => FetchJson.get("/admin-class", data),
    getAdminClassById:(classId:string,data?:object) => FetchJson.get(`/admin-class/${classId}/in-progress`, data),
    getClassById:(classId:string,data:object) => FetchJson.get(`/class/${classId}`, data),
    getClassDetail:(classId:string,data:object) => FetchJson.get(`/class/${classId}/detail`, data),
    getClassChapterById:(classId:string,data:object) => FetchJson.get(`/class/${classId}/chapter`, data),
    getClassDetailById:(classId:string,data:object) => FetchJson.get(`/class/${classId}/detail`, data),
    getClassLearningMaterialById:(classId:string,data:object) => FetchJson.get(`/class/${classId}/learning-material`, data),
    getClassOverviewById:(classId:string,data:object) => FetchJson.get(`/class/${classId}/overview`, data),
    getClassStepById:(classId:string,data?:object) => FetchJson.get(`/class/${classId}/step`, data),
    getClassVideoById:(classId:string,data?:object) => FetchJson.get(`/class/${classId}/class-videos`, data),
    
    // POST
    postAdminClass:(classId,data:object) => FetchJson.post(`/admin-class/${classId}/in-progress`, data),
    postClass:(data) => FetchJson.post(`/class`, data),
    postClassSubmit:(classId:string,) => FetchJson.post(`/class/${classId}/submit`),
    postAdminClassList:(data:object) => FetchJson.post("/admin-class", data),
    // PUT
    putClassDetail:(classId:string,data:object) => FetchJson.put(`/class/${classId}/detail`, data),
    putClassLearningMaterial:(classId:string,data:object) => FetchJson.put(`/class/${classId}/learning-material`, data),
    putClassMessage:(classId:string,data:object) => FetchJson.put(`/class/${classId}/message`, data),
    putClassOverview:(classId:string,data:object) => FetchJson.put(`/class/${classId}/overview`, data),
    putClassQuiz:(classId:string,data:object) => FetchJson.put(`/class/${classId}/quiz`, data),
    putClassVideo:(classId:string,data:object) => FetchJson.post(`/class/${classId}/video`, data),
    // DELETE/
    deleteClassDetail:(classId:string,data:object) => FetchJson.delete(`/class/${classId}`, data),
    deleteClassChapter:(classId:string,chapterId:string,data?:object) => FetchJson.delete(`/class/${classId}/chapter/${chapterId}`, data),
    deleteClassLearningMaterial:(classId:string,data:object) => FetchJson.delete(`/class/${classId}/learning-material`, data),
    deleteClassQuiz:(quizId:string,classId:string,data:object) => FetchJson.delete(`/class/${classId}/quiz/${quizId}`, data),
    deleteClassVideo:(classId:string,data:object) => FetchJson.delete(`/class/${classId}/video`, data),
    deleteClassVideoById:(videoId:string,classId:string) => FetchJson.delete(`/class/${classId}/video/${videoId}`),
    deleteVideoById:(classId:string,chapterId:string,videoId:string) =>
        FetchJson.delete(`/class/${classId}/chapters/${chapterId}/videos/${videoId}`),
}

export { classesAPI };